<app-help-page mainVideo="notification-destinations"
               [tutorials]="['notification-destination-teams']"
               [videos]="['notification-destinations']"></app-help-page>
